import { useState, useEffect } from 'react';

export const useModalsCount = () => {
  const [count, setCount] = useState(0);
  return {
    count,
    incr: () => {
      console.log('incr modal count');
      setCount(count + 1);
    },
    decr: () => {
      console.log('decr modal count');
      setCount(count - 1);
    },
  };
};
